<<template>
  <div class="login-shell">
    <!-- Ambient Background -->
    <div class="ambient-layer">
      <div class="orb orb-blue" />
      <div class="orb orb-teal" />
      <div class="orb orb-gold" />
    </div>

    <!-- Toolbar Modernisée -->
    <v-toolbar dense tabs color="transparent" dark class="glass-toolbar" elevation="0">
      <v-toolbar-title class="pa-0 pr-0 mt-1" style="width: 100%;">
        <v-layout row align-center>
          <v-flex xs10 sm11 text-xs-left class="toolbar-brand">
            <a href="javascript: history.go(-1)" class="pa-0 back-link">
              <v-btn flat fab small class="pa-0 btn-glass">
                <i class="fas fa-arrow-left headline"></i>
              </v-btn>
            </a>
            <span class="toolbar-title-text">Welcome Back</span>
          </v-flex>
          <v-flex xs2 sm1 text-xs-right>
            <router-link :to="$store.state.close_url3" class="pa-0 text-xs-right">
              <v-btn flat fab small class="pa-0 btn-glass">
                <i class="fas fa-close headline"></i>
              </v-btn>
            </router-link>
          </v-flex>
        </v-layout>
      </v-toolbar-title>
    </v-toolbar>

    <!-- ═══════════════════════════════════════
         LOCKOUT DIALOG (Premium Glassmorphism)
         ═══════════════════════════════════════ -->
    <v-dialog v-model="showLockoutDialog" persistent max-width="720" :fullscreen="$vuetify.breakpoint.xsOnly" content-class="lockout-dialog-glass">
      <v-card class="lockout-glass-card">
        <!-- Header -->
        <div class="lockout-glass-header">
          <div class="lockout-brand">
            <img src="/logo.png" alt="PettyCash" class="lockout-logo-img" />
            <div class="lockout-brand-text">
              <span class="petty-blue">Petty</span><span class="cash-green">Cash</span>
            </div>
          </div>
          <div class="lockout-header-glow" />
        </div>

        <v-card-text :class="$vuetify.breakpoint.xsOnly ? 'pa-3' : 'pa-5'">
          <!-- Message Email -->
          <v-card flat class="glass-info-card email-card mb-4">
            <v-layout row align-center :class="$vuetify.breakpoint.xsOnly ? 'text-xs-center' : ''">
              <v-flex shrink :class="$vuetify.breakpoint.xsOnly ? 'xs12 mb-2' : 'mr-4'">
                <div class="icon-pulse-wrap blue-glow">
                  <v-icon size="40" color="white">email</v-icon>
                </div>
              </v-flex>
              <v-flex :class="$vuetify.breakpoint.xsOnly ? 'xs12' : ''">
                <div :class="$vuetify.breakpoint.xsOnly ? 'subheading' : 'title'" class="font-weight-bold blue--text text--darken-2 mb-2">
                  Recovery Email Sent
                </div>
                <p :class="$vuetify.breakpoint.xsOnly ? 'body-2' : 'body-1'" class="mb-2" style="line-height: 1.6; color: #475569;">
                  We've sent detailed instructions to unlock your account to your registered email address.
                </p>
                <v-chip color="primary" text-color="white" small class="font-weight-bold" style="background: linear-gradient(135deg, #00479B, #0066CC);">
                  <v-icon left small>check_circle</v-icon>
                  Check your inbox (including spam)
                </v-chip>
              </v-flex>
            </v-layout>
          </v-card>

          <!-- Timer Section -->
          <v-card flat class="glass-timer-card mb-4">
            <v-layout row align-center :class="$vuetify.breakpoint.xsOnly ? 'text-xs-center' : ''">
              <v-flex xs12 sm5 :class="$vuetify.breakpoint.xsOnly ? 'mb-3' : 'text-xs-center pr-sm-3'">
                <div class="timer-circle-wrap">
                  <v-progress-circular
                    :rotate="-90"
                    :size="$vuetify.breakpoint.xsOnly ? 120 : 150"
                    :width="8"
                    :value="progressPercentage"
                    color="#00479B"
                    class="timer-progress"
                  >
                    <div class="timer-text">
                      <div :class="$vuetify.breakpoint.xsOnly ? 'headline' : 'display-1'" class="blue--text text--darken-3 font-weight-bold">
                        {{ minutesRemaining }}:{{ secondsRemaining.toString().padStart(2, '0') }}
                      </div>
                      <div class="caption grey--text text--darken-1 font-weight-medium">REMAINING</div>
                    </div>
                  </v-progress-circular>
                </div>
              </v-flex>
              <v-flex xs12 sm7>
                <div>
                  <div :class="$vuetify.breakpoint.xsOnly ? 'subheading' : 'title'" class="font-weight-bold blue--text text--darken-3 mb-2">
                    <v-icon color="#00479B" class="mr-2">timer</v-icon>
                    Automatic Unlock
                  </div>
                  <p :class="$vuetify.breakpoint.xsOnly ? 'body-2' : 'body-1'" class="mb-3" style="line-height: 1.6; color: #475569;">
                    For your security, this account will automatically unlock in
                    <span class="font-weight-bold blue--text text--darken-2">{{ minutesRemaining }}m {{ secondsRemaining }}s</span>.
                  </p>
                  <v-progress-linear
                    :value="progressPercentage"
                    height="8"
                    color="#00479B"
                    background-color="#E3F2FD"
                    class="mb-2"
                    rounded
                  ></v-progress-linear>
                  <p class="caption grey--text text--darken-1 mb-0">
                    <v-icon small color="grey darken-1">info</v-icon>
                    You can try logging in again once this timer completes
                  </p>
                </div>
              </v-flex>
            </v-layout>
          </v-card>

          <!-- Security Message -->
          <v-card flat class="glass-info-card security-card mb-3">
            <v-layout row align-center :class="$vuetify.breakpoint.xsOnly ? 'text-xs-center' : ''">
              <v-flex shrink :class="$vuetify.breakpoint.xsOnly ? 'xs12 mb-2' : 'mr-3'">
                <div class="icon-pulse-wrap green-glow">
                  <v-icon color="white" size="28">verified_user</v-icon>
                </div>
              </v-flex>
              <v-flex :class="$vuetify.breakpoint.xsOnly ? 'xs12' : ''">
                <div :class="$vuetify.breakpoint.xsOnly ? 'body-2' : 'body-1'" class="font-weight-bold green--text text--darken-3 mb-1">
                  Your Account Is Secure
                </div>
                <p :class="$vuetify.breakpoint.xsOnly ? 'caption' : 'body-2'" class="mb-0" style="line-height: 1.5; color: #475569;">
                  This temporary lockout protects your financial data from unauthorized access attempts.
                </p>
              </v-flex>
            </v-layout>
          </v-card>

          <!-- Instructions -->
          <v-card flat class="glass-instructions-card">
            <div :class="$vuetify.breakpoint.xsOnly ? 'body-2' : 'body-1'" class="font-weight-bold grey--text text--darken-4 mb-3">
              <v-icon color="grey darken-2">help_outline</v-icon>
              What Should I Do?
            </div>

            <v-timeline dense :class="$vuetify.breakpoint.xsOnly ? 'compact-timeline' : ''">
              <v-timeline-item color="#00479B" small>
                <template v-slot:icon>
                  <span class="white--text font-weight-bold" style="font-size: 12px;">1</span>
                </template>
                <v-card flat class="transparent">
                  <p :class="$vuetify.breakpoint.xsOnly ? 'body-2' : 'body-1'" class="mb-0 font-weight-medium grey--text text--darken-3">
                    Check your email for detailed recovery instructions
                  </p>
                </v-card>
              </v-timeline-item>

              <v-timeline-item color="#F97316" small>
                <template v-slot:icon>
                  <span class="white--text font-weight-bold" style="font-size: 12px;">2</span>
                </template>
                <v-card flat class="transparent">
                  <p :class="$vuetify.breakpoint.xsOnly ? 'body-2' : 'body-1'" class="mb-0 font-weight-medium grey--text text--darken-3">
                    Wait for the automatic unlock ({{ minutesRemaining }} minutes remaining)
                  </p>
                </v-card>
              </v-timeline-item>

              <v-timeline-item color="#10B981" small>
                <template v-slot:icon>
                  <span class="white--text font-weight-bold" style="font-size: 12px;">3</span>
                </template>
                <v-card flat class="transparent">
                  <p :class="$vuetify.breakpoint.xsOnly ? 'body-2' : 'body-1'" class="mb-0 font-weight-medium grey--text text--darken-3">
                    Login again with your correct credentials
                  </p>
                </v-card>
              </v-timeline-item>
            </v-timeline>
          </v-card>
        </v-card-text>

        <v-card-actions class="glass-footer pa-3">
          <v-spacer></v-spacer>
          <p class="caption grey--text text--darken-1 mb-0 text-xs-center" style="width: 100%;">
            <v-icon small color="grey darken-1">info</v-icon>
            All recovery options are available in your email
          </p>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ═══════════════════════════════════════
         MAIN CONTENT
         ═══════════════════════════════════════ -->
    <v-container class="main-container">
      <v-layout row>
        <v-flex xs12 md8 offset-md2 lg6 offset-lg3>
          <v-slide-y-transition mode="out-in">
            <div class="login-content text-xs-center">

              <!-- Welcome Message -->
              <div class="welcome-block animate-enter">
                <div class="welcome-eyebrow">Secure Access</div>
                <h1 class="welcome-title">
                  <span class="petty-blue">Petty</span><span class="cash-green">Cash</span>
                  <span class="sas-gold"> SAS</span>
                </h1>
                <p class="welcome-text">
                  Welcome to our financial educational platform which helps you learn and attain financial discipline.
                </p>
              </div>

              <!-- Info Card -->
              <v-card class="glass-info-banner mb-4 animate-enter" style="animation-delay: .1s">
                <v-card-text class="pa-3">
                  <p class="subheading pa-0 ma-0 text-xs-center" style="color: #00479B; font-weight: 600; font-size: 14px;">
                    Login to have access to features that will help you manage your finances.
                  </p>
                </v-card-text>
              </v-card>

              <!-- Login Form -->
              <v-card class="glass-login-card pa-4 animate-enter" style="animation-delay: .2s" elevation="0">
                <v-layout row>
                  <v-flex xs12 md10 offset-md1>

                    <!-- Username -->
                    <v-layout row align-center class="input-row">
                      <v-flex xs2 sm1 class="input-icon-wrap">
                        <div class="input-icon-circle teal-glow">
                          <i class="fas fa-user-circle"></i>
                        </div>
                      </v-flex>
                      <v-flex xs9 sm10>
                        <v-text-field
                          class="pa-0 modern-input"
                          id="username"
                          v-model="username"
                          ref="username"
                          :rules="[v => !!v || 'Username is required']"
                          label="Username"
                          single-line
                          color="teal"
                          @keyup.enter="logIn"
                          solo
                          flat
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs1>
                        <v-btn
                          @click.stop="showUsernameHelp"
                          flat
                          fab
                          small
                          outline
                          class="help-btn"
                        >
                          <i class="fas fa-question"></i>
                        </v-btn>
                      </v-flex>
                    </v-layout>

                    <!-- Password -->
                    <v-layout row align-center class="input-row">
                      <v-flex xs2 sm1 class="input-icon-wrap">
                        <div class="input-icon-circle teal-glow">
                          <i class="fas fa-lock"></i>
                        </div>
                      </v-flex>
                      <v-flex xs9 sm10>
                        <v-text-field
                          class="pa-0 modern-input"
                          id="password"
                          v-model="password"
                          ref="password"
                          label="Enter Password"
                          :rules="[v => !!v || 'Your Password is required (at least 8 characters)']"
                          single-line
                          color="teal"
                          min="8"
                          :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                          @click:append="() => (showPassword = !showPassword)"
                          :type="showPassword ? 'text' : 'password'"
                          counter
                          @keyup.enter="logIn"
                          solo
                          flat
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs1>
                        <v-btn
                          @click.stop="showPasswordHelp"
                          flat
                          fab
                          small
                          outline
                          class="help-btn"
                        >
                          <i class="fas fa-question"></i>
                        </v-btn>
                      </v-flex>
                    </v-layout>

                  </v-flex>
                </v-layout>

                <!-- Forgot Password -->
                <div class="text-xs-right pa-0 ma-0 mt-2 mb-3">
                  <router-link
                    class="forgot-link"
                    style="cursor: pointer"
                    :to="{name: 'forgot_password'}"
                  >
                    Forgotten your username/password?
                  </router-link>
                </div>

                <!-- Actions -->
                <div class="actions-wrap">
                  <v-layout row wrap justify-center>
                    <v-flex xs7 sm6 class="text-xs-center">
                      <v-btn
                        class="btn-glass-red"
                        round
                        block
                        :to="{name: 'signup'}"
                      >
                        <span>Create Account</span>
                      </v-btn>
                    </v-flex>
                    <v-flex xs5 sm6 class="text-xs-center">
                      <v-btn
                        class="btn-glass-primary"
                        round
                        block
                        @click="logIn"
                        :disabled="!canSubmit || isAccountLocked"
                        :loading="$store.state.isLoading"
                      >
                        <span>Submit</span>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </div>
              </v-card>

              <!-- Trust Footer -->
              <div class="login-trust-footer animate-enter" style="animation-delay: .3s">
                <div class="trust-pill">
                  <v-icon small color="#00479B">mdi-shield-check</v-icon>
                  <span>Bank-Grade Security</span>
                </div>
                <div class="trust-pill">
                  <v-icon small color="#10B981">mdi-lock</v-icon>
                  <span>Encrypted Connection</span>
                </div>
              </div>

            </div>
          </v-slide-y-transition>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import axios from 'axios'

export default {
    data() {
        return {
            showPassword: false,
            prevRoute: null,
            username: "",
            password: "",

            // Lockout state
            showLockoutDialog: false,
            isAccountLocked: false,
            lockoutData: {
                username: '',
                ip_address: '',
                locked_until: null,
                minutes_remaining: 0,
                attempts_count: 0
            },
            minutesRemaining: 0,
            secondsRemaining: 0,
            lockoutDurationMinutes: 30,
            lockoutTimer: null,
        }
    },

    computed: {
        canSubmit() {
            return this.username.length >= 4 && this.password.length >= 8
        },

        progressPercentage() {
            if (!this.lockoutDurationMinutes) return 0
            const totalSeconds = this.lockoutDurationMinutes * 60
            const remainingSeconds = (this.minutesRemaining * 60) + this.secondsRemaining
            const elapsed = totalSeconds - remainingSeconds
            return (elapsed / totalSeconds) * 100
        }
    },

    async mounted() {
        document.title = "PettyCash | Log In"

        const { username, password } = this.$route.query

        if (username) {
            this.username = username
        }

        if (password) {
            this.password = password
        }
        // Vérifier silencieusement le verrouillage
        await this.checkLockoutStatusSilently()

        // Si déjà authentifié, rediriger
        if (this.$store.state.isAuthenticated) {
            this.$store.commit('setSnackBarMessage', "Welcome back " + this.$store.state.username)
            this.$store.commit('setSnackBarColor', "teal darken-4")
            this.$store.commit('activateSnackBar', true)
            this.$router.push("/All")
        }
    },

    beforeRouteEnter(to, from, next) {
        next(vm => {
            if (to.query.to) {
                vm.prevRoute = to.query.to
            } else {
                vm.prevRoute = "/All"
            }
        })
    },

    beforeDestroy() {
        if (this.lockoutTimer) {
            clearInterval(this.lockoutTimer)
        }
    },

    filters: {
        formatDateTime(dateString) {
            if (!dateString) return 'N/A'
            const date = new Date(dateString)
            return date.toLocaleString('en-US', {
                weekday: 'short',
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            })
        }
    },

    methods: {
        async checkLockoutStatusSilently() {
            try {
                const response = await axios.get('/api/v1/home/lockout-info/')

                if (response.data.has_lockout) {
                    const lockout = response.data.lockouts[0]

                    this.isAccountLocked = true
                    this.lockoutData = {
                        username: lockout.username,
                        ip_address: response.data.ip_address,
                        locked_until: lockout.locked_until,
                        attempts_count: lockout.attempts_count
                    }

                    this.showLockoutDialog = true

                    const now = new Date()
                    const until = new Date(lockout.locked_until)
                    this.lockoutDurationMinutes = Math.ceil((until - now) / 60000)
                    const totalSeconds = Math.ceil((until - now) / 1000)
                    this.minutesRemaining = Math.floor(totalSeconds / 60)
                    this.secondsRemaining = totalSeconds % 60

                    this.startLockoutTimer(lockout.locked_until)
                }
            } catch (error) {
                console.error('Lockout check failed:', error)
            }
        },

        handleLockout(data) {
            this.isAccountLocked = true
            this.lockoutData = data
            this.showLockoutDialog = true

            const now = new Date()
            const until = new Date(data.locked_until)
            this.lockoutDurationMinutes = Math.ceil((until - now) / 60000)

            const totalSeconds = Math.ceil((until - now) / 1000)
            this.minutesRemaining = Math.floor(totalSeconds / 60)
            this.secondsRemaining = totalSeconds % 60

            this.startLockoutTimer(data.locked_until)
        },

        startLockoutTimer(lockedUntil) {
            const updateTimer = async () => {
                const now = new Date()
                const until = new Date(lockedUntil)
                const diffMs = until - now

                if (diffMs <= 0) {
                    try {
                        const response = await axios.get('/api/v1/home/lockout-info/')

                        if (!response.data.has_lockout) {
                            this.showLockoutDialog = false
                            this.isAccountLocked = false
                            clearInterval(this.lockoutTimer)

                            this.$store.commit('setSnackBarMessage', "✅ Account unlocked! You can now login with your correct credentials.")
                            this.$store.commit('setSnackBarColor', "green darken-2")
                            this.$store.commit('activateSnackBar', true)
                        }
                    } catch (error) {
                        this.showLockoutDialog = false
                        this.isAccountLocked = false
                        clearInterval(this.lockoutTimer)
                    }
                } else {
                    const totalSeconds = Math.ceil(diffMs / 1000)
                    this.minutesRemaining = Math.floor(totalSeconds / 60)
                    this.secondsRemaining = totalSeconds % 60
                }
            }

            updateTimer()
            this.lockoutTimer = setInterval(updateTimer, 1000)
        },

        showUsernameHelp() {
            this.$store.commit('setDialogTitle', "Your User Name")
            this.$store.commit('setDialogMessage', "Here you are required to input your User Name.")
            this.$store.commit('activateDialog', true)
        },

        showPasswordHelp() {
            this.$store.commit('setDialogTitle', "Your Password")
            this.$store.commit('setDialogMessage',
                "You are required to input your account password. This password needs to be at least 8 characters long. " +
                "It is also advisable for you to write down this password so in case you forget, you can know where to get it."
            )
            this.$store.commit('activateDialog', true)
        },

        async logIn() {
            if (this.username.length < 4) {
                this.$store.commit('setSnackBarMessage', "Username must be at least 4 characters")
                this.$store.commit('setSnackBarColor', "orange darken-2")
                this.$store.commit('activateSnackBar', true)
                return
            }

            if (this.password.length < 8) {
                this.$store.commit('setSnackBarMessage', "Password must be at least 8 characters")
                this.$store.commit('setSnackBarColor', "orange darken-2")
                this.$store.commit('activateSnackBar', true)
                return
            }

            if (this.isAccountLocked) {
                this.showLockoutDialog = true
                return
            }

            try {
                await axios.post('/api/v1/home/check-lockout/', {
                    username: this.username
                })
            } catch (error) {
                if (error.response && error.response.status === 423) {
                    this.handleLockout(error.response.data)
                    return
                }
            }

            this.$store.commit('setIsLoading', true)
            axios.defaults.headers.common['Authorization'] = ""
            localStorage.removeItem('token')

            try {
                const formData = {
                    username: this.username,
                    password: this.password
                }

                const loginResponse = await axios.post('/api/v1/token/login/', formData)
                const token = loginResponse.data.auth_token

                this.$store.commit('setToken', token)
                axios.defaults.headers.common['Authorization'] = "Token " + token
                localStorage.setItem('token', token)
                this.$store.state.username = this.username

                this.isAccountLocked = false

                const profileResponse = await axios.get('/api/v1/home/user/profile/')

                if (profileResponse.data.payment_status) {
                    this.$store.commit('setSnackBarMessage', `Welcome to Business Suite, ${this.username}! 🎉`)
                    this.$store.commit('setSnackBarColor', "teal darken-4")
                    this.$store.commit('activateSnackBar', true)
                    return this.$router.push('/business-account/dashboard')
                }

                if (this.$store.state.acceptedNjangiGroup) {
                    const group_id = this.$store.state.acceptedNjangiGroupId
                    const njangiResponse = await axios.post(`/api/v1/njangi/accept/invitation/${group_id}/`)

                    this.$store.commit('setSnackBarMessage', "Welcome back " + this.username + " 😃")
                    this.$store.commit('setSnackBarColor', "teal darken-4")
                    this.$store.commit('activateSnackBar', true)

                    if (njangiResponse.data[0].id !== 0) {
                        setTimeout(() => {
                            this.$router.push(`/njangi/groups/detail/${group_id}/`)
                            this.$store.commit('setSnackBarMessage', njangiResponse.data[0].text)
                            this.$store.commit('setSnackBarColor', njangiResponse.data[0].color)
                            this.$store.commit('activateSnackBar', true)
                        }, 4000)
                    }
                } else {
                    this.$router.push(this.prevRoute)
                    this.$store.commit('setSnackBarMessage', "Welcome back " + this.username + " 😃")
                    this.$store.commit('setSnackBarColor', "teal darken-4")
                    this.$store.commit('activateSnackBar', true)
                }

            } catch (error) {
                if (error.response) {
                    const status = error.response.status
                    const data = error.response.data

                    if (status === 429 || status === 423) {
                        this.handleLockout(data)
                    } else if (status === 400 || status === 401) {
                        let errorMessage = "Invalid credentials"
                        if (data.non_field_errors) {
                            errorMessage = data.non_field_errors[0]
                        } else {
                            for (const property in data) {
                                if (Array.isArray(data[property])) {
                                    errorMessage = data[property][0]
                                    break
                                }
                            }
                        }

                        this.$store.commit('setSnackBarMessage', errorMessage)
                        this.$store.commit('setSnackBarColor', "red darken-4")
                        this.$store.commit('activateSnackBar', true)
                    } else {
                        this.$store.commit('setSnackBarMessage', `Server error: ${status}`)
                        this.$store.commit('setSnackBarColor', "red darken-4")
                        this.$store.commit('activateSnackBar', true)
                    }
                } else if (error.request) {
                    this.$store.commit('setSnackBarMessage', "Network error - Please check your connection")
                    this.$store.commit('setSnackBarColor', "red darken-4")
                    this.$store.commit('activateSnackBar', true)
                } else {
                    this.$store.commit('setSnackBarMessage', "An unexpected error occurred")
                    this.$store.commit('setSnackBarColor', "red darken-4")
                    this.$store.commit('activateSnackBar', true)
                }
            } finally {
                this.$store.commit('setIsLoading', false)
            }
        }
    }
}
</script>

<style scoped>
/* ═══════════════════════════════════════
   DESIGN TOKENS & RESET
   ═══════════════════════════════════════ */
.login-shell {
  --pc-primary: #00479B;
  --pc-primary-light: #0066CC;
  --pc-teal: #009688;
  --pc-green: #10B981;
  --pc-orange: #F97316;
  --pc-gold: #D4AF37;
  --pc-bg: #F8FAFC;
  --pc-surface: rgba(255, 255, 255, 0.75);
  --pc-text: #0F172A;
  --pc-muted: #64748B;
  --pc-border: rgba(255, 255, 255, 0.5);
  min-height: 100vh;
  background: linear-gradient(180deg, #F0F7FF 0%, #F8FAFC 40%, #FFFFFF 100%);
  position: relative;
  overflow-x: hidden;
  font-family: 'Inter', system-ui, -apple-system, sans-serif;
}

.petty-blue { color: #00479B; }
.cash-green { color: #10B981; }
.sas-gold { color: #D4AF37; font-size: 0.55em; font-weight: 700; vertical-align: super; margin-left: 0.15em; }

/* ═══════════════════════════════════════
   AMBIENT BACKGROUND
   ═══════════════════════════════════════ */
.ambient-layer {
  position: fixed;
  inset: 0;
  pointer-events: none;
  z-index: 0;
  overflow: hidden;
}

.orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(80px);
  opacity: 0.3;
  animation: orbDrift 20s ease-in-out infinite alternate;
}

.orb-blue {
  width: 500px;
  height: 500px;
  background: #00479B;
  top: -10%;
  right: -5%;
  animation-duration: 25s;
}

.orb-teal {
  width: 400px;
  height: 400px;
  background: #009688;
  bottom: 10%;
  left: -10%;
  animation-duration: 30s;
  animation-delay: -5s;
}

.orb-gold {
  width: 300px;
  height: 300px;
  background: #D4AF37;
  top: 40%;
  left: 40%;
  opacity: 0.15;
  animation-duration: 22s;
  animation-delay: -10s;
}

@keyframes orbDrift {
  from { transform: translate(0, 0) scale(1); }
  to { transform: translate(40px, -40px) scale(1.1); }
}

/* ═══════════════════════════════════════
   TOOLBAR
   ═══════════════════════════════════════ */
.glass-toolbar {
  background: rgba(255, 255, 255, 0.6) !important;
  backdrop-filter: blur(12px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.6);
  position: relative;
  z-index: 2;
}

.toolbar-brand {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.back-link {
  text-decoration: none;
}

.btn-glass {
  background: rgba(0, 71, 155, 0.08) !important;
  color: #00479B !important;
  transition: all 0.3s ease;
}

.btn-glass:hover {
  background: rgba(0, 71, 155, 0.15) !important;
  transform: translateY(-1px);
}

.toolbar-title-text {
  font-size: 1.25rem;
  font-weight: 700;
  color: #0F172A;
  letter-spacing: -0.02em;
}

/* ═══════════════════════════════════════
   LOCKOUT DIALOG GLASSMORPHISM
   ═══════════════════════════════════════ */
.lockout-dialog-glass {
  border-radius: 1.5rem !important;
  overflow: visible;
}

.lockout-glass-card {
  background: rgba(255, 255, 255, 0.85) !important;
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.6);
  border-radius: 1.5rem !important;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.15) !important;
  overflow: hidden;
}

.lockout-glass-header {
  position: relative;
  background: linear-gradient(135deg, #00479B 0%, #0066CC 50%, #009688 100%);
  padding: 2.5rem 2rem 2rem;
  text-align: center;
  overflow: hidden;
}

.lockout-header-glow {
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle at 50% 0%, rgba(255,255,255,0.25), transparent 60%);
  pointer-events: none;
}

.lockout-brand {
  position: relative;
  z-index: 2;
}

.lockout-logo-img {
  width: 80px;
  height: auto;
  margin-bottom: 0.75rem;
  filter: drop-shadow(0 4px 12px rgba(0,0,0,0.2));
}

.lockout-brand-text {
  font-size: 1.75rem;
  font-weight: 800;
  color: white;
  letter-spacing: -0.02em;
}

/* Glass Cards inside dialog */
.glass-info-card {
  background: rgba(255, 255, 255, 0.7) !important;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 1rem !important;
  padding: 1.25rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05) !important;
  transition: transform 0.3s ease;
}

.glass-info-card:hover {
  transform: translateY(-2px);
}

.email-card {
  border-left: 4px solid #00479B;
}

.security-card {
  border-left: 4px solid #10B981;
}

.glass-timer-card {
  background: linear-gradient(135deg, rgba(255,255,255,0.9), rgba(240,247,255,0.9)) !important;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(0, 71, 155, 0.1);
  border-radius: 1rem !important;
  padding: 1.5rem;
  box-shadow: 0 4px 15px rgba(0, 71, 155, 0.08) !important;
}

.glass-instructions-card {
  background: rgba(255, 255, 255, 0.6) !important;
  backdrop-filter: blur(8px);
  border: 1px solid rgba(255, 255, 255, 0.4);
  border-radius: 1rem !important;
  padding: 1.25rem;
}

.glass-footer {
  background: rgba(241, 245, 249, 0.6) !important;
  backdrop-filter: blur(8px);
  border-top: 1px solid rgba(255, 255, 255, 0.5);
}

/* Icon Pulses */
.icon-pulse-wrap {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.blue-glow {
  background: linear-gradient(135deg, #00479B, #0066CC);
  box-shadow: 0 8px 24px rgba(0, 71, 155, 0.35);
  animation: iconFloat 3s ease-in-out infinite;
}

.green-glow {
  background: linear-gradient(135deg, #10B981, #059669);
  box-shadow: 0 8px 24px rgba(16, 185, 129, 0.35);
  animation: iconFloat 3s ease-in-out infinite 1s;
}

@keyframes iconFloat {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-6px); }
}

/* Timer */
.timer-circle-wrap {
  display: inline-flex;
  position: relative;
}

.timer-circle-wrap::before {
  content: '';
  position: absolute;
  inset: -8px;
  border-radius: 50%;
  background: rgba(0, 71, 155, 0.06);
  animation: breathe 3s ease-in-out infinite;
}

@keyframes breathe {
  0%, 100% { transform: scale(1); opacity: 0.6; }
  50% { transform: scale(1.05); opacity: 1; }
}

.timer-progress {
  background: white;
  border-radius: 50%;
  box-shadow: 0 4px 12px rgba(0, 71, 155, 0.1);
}

.timer-text {
  text-align: center;
}

/* Timeline polish */
.v-timeline {
  padding-left: 36px !important;
}

.v-timeline-item {
  padding-bottom: 16px !important;
}

/* ═══════════════════════════════════════
   MAIN LOGIN CONTENT
   ═══════════════════════════════════════ */
.main-container {
  position: relative;
  z-index: 1;
  padding-top: 2rem;
  padding-bottom: 3rem;
}

.login-content {
  max-width: 480px;
  margin: 0 auto;
}

/* Welcome Block */
.welcome-block {
  margin-bottom: 2rem;
}

.welcome-eyebrow {
  display: inline-block;
  font-size: 0.875rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #00479B;
  background: rgba(0, 71, 155, 0.06);
  padding: 0.35rem 0.9rem;
  border-radius: 999px;
  margin-bottom: 0.75rem;
}

.welcome-title {
  font-size: clamp(2rem, 5vw, 3rem);
  font-weight: 800;
  line-height: 1.1;
  letter-spacing: -0.03em;
  margin-bottom: 1rem;
  color: #0F172A;
}

.welcome-text {
  font-size: 1rem;
  color: #64748B;
  line-height: 1.7;
  max-width: 360px;
  margin: 0 auto;
}

/* Info Banner */
.glass-info-banner {
  background: linear-gradient(135deg, rgba(227, 242, 253, 0.8), rgba(187, 222, 251, 0.6)) !important;
  backdrop-filter: blur(8px);
  border: 1px solid rgba(255, 255, 255, 0.6);
  border-radius: 1rem !important;
  box-shadow: 0 4px 6px -1px rgba(0, 71, 155, 0.05) !important;
}

/* Login Card */
.glass-login-card {
  background: rgba(255, 255, 255, 0.8) !important;
  backdrop-filter: blur(16px);
  border: 1px solid rgba(255, 255, 255, 0.6);
  border-radius: 1.25rem !important;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.08), 0 8px 10px -6px rgba(0, 0, 0, 0.02) !important;
}

/* Input Rows */
.input-row {
  margin-bottom: 0.5rem;
}

.input-icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
}

.input-icon-circle {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.25rem;
  color: white;
  background: linear-gradient(135deg, #009688, #4DB6AC);
  box-shadow: 0 4px 12px rgba(0, 150, 136, 0.25);
}

.teal-glow {
  animation: subtlePulse 3s ease-in-out infinite;
}

@keyframes subtlePulse {
  0%, 100% { box-shadow: 0 4px 12px rgba(0, 150, 136, 0.25); }
  50% { box-shadow: 0 6px 20px rgba(0, 150, 136, 0.4); }
}

/* Modern Inputs */
.modern-input >>> .v-input__slot {
  background: rgba(241, 245, 249, 0.6) !important;
  border-radius: 0.75rem !important;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.02) !important;
  border: 1px solid rgba(226, 232, 240, 0.8) !important;
  transition: all 0.3s ease;
  min-height: 48px;
  padding: 0 0.75rem !important;
}

.modern-input.v-input--is-focused >>> .v-input__slot {
  background: white !important;
  border-color: rgba(0, 150, 136, 0.4) !important;
  box-shadow: 0 0 0 3px rgba(0, 150, 136, 0.08), 0 4px 6px -1px rgba(0, 0, 0, 0.05) !important;
}

.modern-input >>> input {
  font-size: 1rem;
  font-weight: 500;
  color: #0F172A;
}

.modern-input >>> .v-label {
  color: #94A3B8;
  font-weight: 500;
}

/* Help Button */
.help-btn {
  width: 28px !important;
  height: 28px !important;
  border-color: #CBD5E1 !important;
  color: #64748B !important;
  transition: all 0.2s ease;
}

.help-btn:hover {
  border-color: #00479B !important;
  color: #00479B !important;
  background: rgba(0, 71, 155, 0.04) !important;
}

.help-btn i {
  font-size: 0.75rem;
}

/* Forgot Link */
.forgot-link {
  color: #00479B;
  font-size: 0.875rem;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.2s;
}

.forgot-link:hover {
  color: #0066CC;
  text-decoration: underline;
}

/* Action Buttons */
.actions-wrap {
  margin-top: 1.5rem;
}

.btn-glass-red {
  background: linear-gradient(135deg, #EF4444, #DC2626) !important;
  color: white !important;
  font-weight: 700 !important;
  text-transform: none !important;
  letter-spacing: 0.01em;
  box-shadow: 0 4px 14px rgba(239, 68, 68, 0.3) !important;
  transition: all 0.3s ease;
  height: 44px !important;
}

.btn-glass-red:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(239, 68, 68, 0.4) !important;
}

.btn-glass-primary {
  background: linear-gradient(135deg, #00479B, #0066CC) !important;
  color: white !important;
  font-weight: 700 !important;
  text-transform: none !important;
  letter-spacing: 0.01em;
  box-shadow: 0 4px 14px rgba(0, 71, 155, 0.3) !important;
  transition: all 0.3s ease;
  height: 44px !important;
}

.btn-glass-primary:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 71, 155, 0.4) !important;
}

.btn-glass-primary:disabled {
  opacity: 0.5 !important;
  cursor: not-allowed !important;
}

/* Trust Footer */
.login-trust-footer {
  display: flex;
  justify-content: center;
  gap: 0.75rem;
  margin-top: 2rem;
  flex-wrap: wrap;
}

.trust-pill {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(8px);
  border: 1px solid rgba(255, 255, 255, 0.5);
  padding: 0.5rem 1rem;
  border-radius: 999px;
  font-size: 0.8rem;
  font-weight: 600;
  color: #475569;
  box-shadow: 0 2px 4px rgba(0,0,0,0.04);
}

/* ═══════════════════════════════════════
   ANIMATIONS
   ═══════════════════════════════════════ */
.animate-enter {
  opacity: 0;
  transform: translateY(20px);
  animation: enterUp 0.7s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

@keyframes enterUp {
  to { opacity: 1; transform: translateY(0); }
}

/* Dialog entrance */
.v-dialog__content .lockout-glass-card {
  animation: dialogEnter 0.5s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes dialogEnter {
  from { opacity: 0; transform: scale(0.95) translateY(20px); }
  to { opacity: 1; transform: scale(1) translateY(0); }
}

/* ═══════════════════════════════════════
   RESPONSIVE
   ═══════════════════════════════════════ */
@media (max-width: 600px) {
  .glass-toolbar { padding: 0 0.5rem; }
  .toolbar-title-text { font-size: 1.1rem; }
  .main-container { padding-top: 1.5rem; }
  .welcome-title { font-size: 1.75rem; }
  .glass-login-card { padding: 1.25rem !important; }
  .input-icon-circle { width: 38px; height: 38px; font-size: 1rem; }
  .lockout-glass-header { padding: 2rem 1rem 1.5rem; }
  .lockout-brand-text { font-size: 1.5rem; }
  .icon-pulse-wrap { width: 56px; height: 56px; }
}

@media (min-width: 960px) {
  .main-container { padding-top: 3rem; }
  .glass-login-card { padding: 2rem !important; }
}
</style>